import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useFilterButton } from '../../../provider/FilterButtonProvider'
import { Form, Field, FieldProps, FormikProps, FormikValues, useFormikContext } from 'formik'

import LocationSelect from '../../form/LocationSelect'
import CheckboxField from '../../form/CheckboxField'
import SelectField from '../../form/SelectField'
import TextField from '../../form/TextField'
import Button from '../../ui/button'
import Index from '../../ui/popup'

import { genders, ages } from '../../../constants'

import './profilesFilter.sass'
import { fixAppContainer, unfixAppContainer } from '../../../store/common/commonSlice'
import { useDispatch } from 'react-redux'
import { memo, useEffect, useRef, useState } from 'react'
import { ShapedButton } from '../../ui/shapedButton/ShapedButton'
import ChosenFilter from '../../ui/chosenFilter/ChosenFilter'
import Paragraph from '../../ui/paragraph/paragraph'
import { initialProfilesValues } from '../../../pages/profiles/profiles'

type Labels = {
    photo: string
    certified: string
    contribution: string
    recently_online: string
}

interface Props {
    showMoreFilters: boolean
    setShowMoreFilters: (state: boolean) => void
}

const ProfilesFilter: React.FunctionComponent<Props> = ({ showMoreFilters, setShowMoreFilters }: Props) => {
    useFilterButton(showMoreFilters, setShowMoreFilters)
    const [t] = useTranslation()
    const dispatch = useDispatch()
    const formik = useFormikContext()
    const chosenCountry = useRef<string | null>('')
    const chosenRegion = useRef<string | null>('')
    const [readebleFilters, setReadebleFilters] = useState<{ label: string; callback: () => void }[] | null>(null)

    const labels: Labels = {
        photo: t('With album photo'),
        certified: t('Certified amateurs'),
        contribution: t('With contributions'),
        recently_online: t('Online within 10 days')
    }

    const filters = {
        p: 1,
        age: ages.map((item) => item.label),
        gender: genders.map((item) => item.label),
        region: chosenRegion.current,
        country: chosenCountry.current,
        photo: t('With album photo'),
        certified: t('Certified amateurs'),
        contribution: t('With contributions'),
        recently_online: t('Online within 10 days')
    }

    const handleCheckbox = (form: FormikProps<FormikValues>) => {
        !showMoreFilters && form.handleSubmit()
    }

    const renderCheckboxes = (): React.ReactElement[] => {
        return Object.keys(labels).map((key: keyof Labels, index: number) => {
            return (
                <Field name={key} key={index}>
                    {({ field, form }: FieldProps) => (
                        <CheckboxField
                            form={form}
                            field={field}
                            label={labels[key]}
                            onChangeCallback={handleCheckbox}
                        />
                    )}
                </Field>
            )
        })
    }

    const formikValuesToArray = () => {
        const initialValues = initialProfilesValues
        // @ts-ignore
        const currentValues = formik.getFieldProps().value
        const values = []

        const createObjLabelCallback = (key: string, value: string) => {
            return {
                label: value,
                callback: function () {
                    formik.setFieldValue(key, initialValues[key])
                    formik.submitForm()
                }
            }
        }

        for (const key in currentValues) {
            if (currentValues[key] !== initialValues[key])
                Object.prototype.hasOwnProperty.call(filters, key)
                    ? values.push(
                          typeof filters[key] === 'string'
                              ? createObjLabelCallback(key, filters[key])
                              : createObjLabelCallback(key, filters[key][currentValues[key]])
                      )
                    : values.push(createObjLabelCallback(key, currentValues[key]))
        }
        return values
    }

    useEffect(() => {
        setReadebleFilters(formikValuesToArray())
        // @ts-ignore
    }, [formik.getFieldProps().value])

    useEffect(() => {
        chosenRegion.current = ''
        formik.setFieldValue('region', '')
        // formik.submitForm()
    }, [chosenCountry.current])

    return (
        <div
            className="filter"
            onKeyDownCapture={(e) => {
                if (e.key === 'Enter') {
                    document.getElementById('key_submit').click()
                }
            }}
        >
            <Form>
                {showMoreFilters ? (
                    <Index
                        onClose={() => {
                            setShowMoreFilters(false)
                            dispatch(unfixAppContainer())
                        }}
                    >
                        <div className="filterContent">
                            <Field name="query">
                                {({ field }: FieldProps) => (
                                    <TextField placeholder={t('User nick')} type="text" field={field} />
                                )}
                            </Field>
                            <div className="selects">
                                <Field name="gender">
                                    {({ field, form }: FieldProps) => (
                                        <SelectField form={form} field={field} label={t('Gender')} options={genders} />
                                    )}
                                </Field>
                                <Field name="age">
                                    {({ field, form }: FieldProps) => (
                                        <SelectField form={form} field={field} label={t('Age')} options={ages} />
                                    )}
                                </Field>
                            </div>
                            <div className={'locationSelect'}>
                                <LocationSelect
                                    initialCountry="France"
                                    initialRegion={null}
                                    currentCountry={chosenCountry}
                                    currentRegion={chosenRegion}
                                />
                            </div>
                            <div className="checkboxes">{renderCheckboxes()}</div>
                            <Button id={'key_submit'} label={t('Search')} type="submit" />
                        </div>
                    </Index>
                ) : (
                    <>
                        <div className={'pageRow_responsive'}>
                            <Paragraph text={t('Profiles info')} />
                            <ShapedButton
                                onclick={() => {
                                    setShowMoreFilters(true)
                                    dispatch(fixAppContainer())
                                }}
                            />
                        </div>

                        <div className={'chosenFiltersContainer'}>
                            {
                                // for (key in formik.getFieldProps().value) console.log(formik.getFieldProps().value[key])
                                // console.log(formik.initialValues)
                            }

                            {readebleFilters ? (
                                readebleFilters.map(
                                    (item, index) =>
                                        item.label && (
                                            <ChosenFilter key={index} filter={item.label} onClick={item.callback} />
                                        )
                                )
                            ) : (
                                <></>
                            )}
                        </div>
                    </>
                )}
            </Form>
        </div>
    )
}

export default memo(ProfilesFilter)
